export default "__VITE_ASSET__89f49ed9__"